import { Vue, Component } from 'nuxt-property-decorator'

// @ts-ignore
import vuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'

Vue.component('FormError', templates.singleErrorExtractor.foundation6)
Vue.use(vuelidateErrorExtractor, {
  template: templates.singleErrorExtractor.foundation6,
  messages: {
    required: 'Obbligatorio',
    email: 'Formato email non valido',
    sameAs: 'Deve essere accettato',
  },
})

@Component
export default class Extractors extends Vue {}
